import { render, staticRenderFns } from "./sales-details.vue?vue&type=template&id=bc3319b2&scoped=true"
import script from "./sales-details.vue?vue&type=script&lang=js"
export * from "./sales-details.vue?vue&type=script&lang=js"
import style0 from "./sales-details.vue?vue&type=style&index=0&id=bc3319b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3319b2",
  null
  
)

export default component.exports